import {ChangeDetectionStrategy, Component} from '@angular/core'
import {DialogModule} from '../../../../../craft/dialog/dialog.module'
import {faPhone} from '@fortawesome/pro-solid-svg-icons/faPhone'
import {Monologic} from '../../../../../craft/dialog/monologic.interface'
import {FaIconComponent} from '@fortawesome/angular-fontawesome'
import {PipesModule} from '../../../../pipes/pipes.module'
import {TranslocoDirective} from '@ngneat/transloco'
import {faEnvelope} from '@fortawesome/pro-solid-svg-icons/faEnvelope'

@Component({
  standalone: true,
  imports: [DialogModule, FaIconComponent, PipesModule, TranslocoDirective],
  template: `
    <cft-dialog *transloco="let t" [title]="t('shared.damageBox.contactModal.title')" size="sm">
      <cft-dialog-content>
        <div class="flex flex-col gap-md">
          <div class="text-sm">
            {{ t('shared.damageBox.contactModal.description') }}
          </div>
          <div class="flex flex-col gap-xs">
            @if (data.phoneNumber) {
              <a
                [href]="data.phoneNumber | bgoTel"
                class="btn-sm btn flex justify-start gap-xs border border-grey-200 font-normal"
              >
                <fa-icon [icon]="faPhoneIcon"></fa-icon>
                <span>{{ t('shared.damageBox.contactModal.phoneAction', {phoneNumber: data.phoneNumber}) }}</span>
              </a>
            }
            @if (data.email) {
              <a
                [href]="data.email | bgoMailTo"
                class="btn-sm btn flex justify-start gap-xs border border-grey-200 font-normal"
              >
                <fa-icon [icon]="faEmailIcon"></fa-icon>
                <span>{{ t('shared.damageBox.contactModal.emailAction', {email: data.email}) }}</span>
              </a>
            }
          </div>
        </div>
      </cft-dialog-content>
    </cft-dialog>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactModalComponent implements Monologic<Props> {
  protected readonly faPhoneIcon = faPhone
  protected readonly faEmailIcon = faEnvelope

  protected data!: Props

  setData(data: Props): void {
    this.data = data
  }
}

export interface Props {
  phoneNumber?: string
  email?: string
}
